
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Gift"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Gift"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftMeta"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Person"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"charity"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Charity"},"directives":[]}]}}]}}],"loc":{"start":0,"end":235}};
    doc.loc.source = {"body":"#import \"~/graphql/fragments/Charity\"\n#import \"~/graphql/fragments/GiftMeta\"\n#import \"~/graphql/fragments/Person\"\n\nfragment Gift on Gift {\n  id\n  meta {\n    ...GiftMeta\n  }\n  person {\n    ...Person\n  }\n  charity {\n    ...Charity\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/Charity").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/GiftMeta").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/Person").definitions));


      module.exports = doc;
    
